import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"

import { request } from "shared/api/request"
import { serializer } from "shared/api/serializer/serializer"
import { raiseToast } from "shared/lib/toast/raiseToast"
import { useEvent } from "shared/lib/useEvent"
import { SendShareLinksAPIType } from "shared/types/ShareLink"
import { ToastType } from "shared/types/Toast"

export interface ShareLinkInviteEmailFormData {
  projectID: string
  email: string
  comment?: string
}

export function useSendShareLinkInvite() {
  const { t } = useTranslation()
  return useEvent((data: ShareLinkInviteEmailFormData) => {
    const loadingToast = raiseToast({
      message: t("Request.ShareEmail.SEND_SHARE_EMAIL.Start"),
      type: ToastType.LOADING
    })
    return request(
      `${import.meta.env.VITE_API_BASE}/project-list/projects/${
        data.projectID
      }/share-links/send`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          serializer.serialize(SendShareLinksAPIType, {
            email: data.email,
            comment: data.comment ?? ""
          })
        )
      }
    )
      .then(res => {
        toast.dismiss(loadingToast)
        if (res?.ok) {
          raiseToast({
            message: t("Request.ShareEmail.SEND_SHARE_EMAIL.Success"),
            type: ToastType.SUCCESS
          })
          return { success: true }
        }
        throw Error("Response not ok!")
      })
      .catch(() => {
        raiseToast({
          message: t("Request.ShareEmail.SEND_SHARE_EMAIL.Failure"),
          type: ToastType.ERROR
        })
        return { success: false }
      })
  })
}
